<template>
  <page title="SaaS Dashboard" :loading="loading" wide>
    <template #controls>
      <form-button icon="fal fa-chart-column" @click="setActiveTab(0)">Dashboard</form-button>
      <form-button icon="fal fa-signal-stream" @click="setActiveTab(1)">Devices</form-button>
    </template>
    <template slot="body">
      <div class="dashboard-container" v-if="tabActive === 0">
        <div class="stats-grid">

          <div class="stat-card">
            <div class="stat-content">
              <div class="header-card">
                <div class="stat-badge">TVL</div>
                <div class="stat-label">TOTAL DEVICES</div>
              </div>
              <div class="stat-values-container">
                <div class="stat-item">
                  <div class="stat-badge green">
                    <i class="fa-light fa-signal-stream"></i>
                    <span>BILLABLE</span>
                  </div>
                  <h3 class="stat-value">{{ formatNumber(stats.tvl.billable) }}</h3>
                </div>
                <div class="stat-item">
                  <div class="stat-badge red">
                    <i class="fa-light fa-signal-stream-slash"></i>
                    <span>NON-BILLABLE</span>
                  </div>
                  <h3 class="stat-value stat-value-muted">{{ formatNumber(stats.tvl.nonBillable) }}</h3>
                </div>
              </div>
              <div class="stat-footer">
                <div class="stat-trend">
                  <span class="stat-trend-icon"></span>
                  <span class="stat-trend-text">+2.4% since last week</span>
                </div>
                <span v-if="billingTerm.tvl" class="stat-term-badge">
                  {{ formatBillingTerm(billingTerm.tvl) }}
                </span>
              </div>
            </div>
          </div>

          <div class="stat-card">
            <div class="stat-content">
              <div class="header-card">
                <div class="stat-badge">API</div>
                <div class="stat-label">TOTAL DEVICES</div>
              </div>
              <div class="stat-values-container">
                <div class="stat-item">
                  <div class="stat-badge green">
                    <i class="fa-light fa-signal-stream"></i>
                    <span>BILLABLE</span>
                  </div>
                  <h3 class="stat-value">{{ formatNumber(stats.api.billable) }}</h3>
                </div>
                <div class="stat-item">
                  <div class="stat-badge red">
                    <i class="fa-light fa-signal-stream-slash"></i>
                    <span>NON-BILLABLE</span>
                  </div>
                  <h3 class="stat-value stat-value-muted">{{ formatNumber(stats.api.nonBillable) }}</h3>
                </div>
              </div>
              <div class="stat-footer">
                <div class="stat-trend">
                  <span class="stat-trend-icon"></span>
                  <span class="stat-trend-text">0% since last week</span>
                </div>
                <span v-if="billingTerm.api" class="stat-term-badge">
                  {{ formatBillingTerm(billingTerm.api) }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="chart-card">
          <div class="chart-header">
            <h2 class="chart-title">Historical Evolution (12 Months)</h2>
            <div class="chart-actions">
              <button class="chart-btn">Export</button>
              <button class="chart-btn">
                <i class="fal fa-sync"></i>
              </button>
            </div>
          </div>
          <div class="chart-container">
            <canvas ref="evolutionChartCanvas"></canvas>
          </div>
        </div>

        <div class="metrics-carousel">
          <button
            type="button"
            class="metrics-nav"
            aria-label="Previous metrics"
            :disabled="!metricsScrollCanPrev"
            @click="scrollMetrics(-1)"
          >
            <i class="fal fa-chevron-left"></i>
          </button>
          <div
            ref="metricsScroll"
            class="metrics-scroll"
            @scroll.passive="updateMetricsScrollNav"
          >
            <div class="metrics-grid">
              <!-- <div class="metric-card">
                <p class="metric-title">Monthly</p>
                <div class="metric-content">
                  <div class="metric-row">
                    <span class="metric-label">TVL</span>
                    <span class="metric-value">{{ formatNumber(metrics.monthly.devices) }}</span>
                  </div>
                  <div class="metric-row">
                    <span class="metric-label">APIs</span>
                    <span class="metric-value">{{ formatNumber(metrics.monthly.apis) }}</span>
                  </div>
                </div>
              </div>

              <div class="metric-card">
                <p class="metric-title">Prepaid</p>
                <div class="metric-content">
                  <div class="metric-row">
                    <span class="metric-label">TVL</span>
                    <span class="metric-value">{{ formatNumber(metrics.longTerm.devices) }}</span>
                  </div>
                  <div class="metric-row">
                    <span class="metric-label">APIs</span>
                    <span class="metric-value">{{ formatNumber(metrics.longTerm.apis) }}</span>
                  </div>
                </div>
              </div> -->
              <div class="metric-card">
                <p class="metric-title">Paused/Disabled</p>
                <div class="metric-content">
                  <div class="metric-row">
                    <span class="metric-label">TVL</span>
                    <span class="metric-value metric-value-disabled">{{ formatNumber(metrics.sleepDisabled.tvl)
                    }}</span>
                  </div>
                  <div class="metric-row">
                    <span class="metric-label">APIs</span>
                    <span class="metric-value metric-value-disabled">{{ formatNumber(metrics.sleepDisabled.api.paused)
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="metric-card">
                <p class="metric-title">Trial <span class="metric-note">(Non-bill)</span></p>
                <div class="metric-content">
                  <div class="metric-row">
                    <span class="metric-label">TVL</span>
                    <span class="metric-value metric-value-primary">{{ formatNumber(metrics.trial.devices) }}</span>
                  </div>
                  <div class="metric-row">
                    <span class="metric-label">APIs</span>
                    <span class="metric-value metric-value-primary">{{ formatNumber(metrics.trial.apis) }}</span>
                  </div>
                </div>
              </div>

              <div class="metric-card">
                <p class="metric-title">Non-billable</p>
                <div class="metric-content">
                  <div class="metric-row">
                    <span class="metric-label">TVL</span>
                    <span class="metric-value metric-value-muted">{{ formatNumber(metrics.nonBillable.devices) }}</span>
                  </div>
                  <div class="metric-row">
                    <span class="metric-label">APIs</span>
                    <span class="metric-value metric-value-muted">{{ formatNumber(metrics.nonBillable.apis) }}</span>
                  </div>
                </div>
              </div>

              <div class="metric-card">
                <p class="metric-title">RND</p>
                <div class="metric-content">
                  <div class="metric-row">
                    <span class="metric-label">TVL</span>
                    <span class="metric-value">{{ formatNumber(metrics.rnd.devices) }}</span>
                  </div>
                  <div class="metric-row">
                    <span class="metric-label">APIs</span>
                    <span class="metric-value">{{ formatNumber(metrics.rnd.apis) }}</span>
                  </div>
                </div>
              </div>

              <div class="metric-card">
                <p class="metric-title">Marketing Devices</p>
                <div class="metric-content">
                  <div class="metric-row">
                    <span class="metric-label">TVL</span>
                    <span class="metric-value">{{ formatNumber(metrics.marketingDevices.devices) }}</span>
                  </div>
                  <div class="metric-row">
                    <span class="metric-label">APIs</span>
                    <span class="metric-value">{{ formatNumber(metrics.marketingDevices.apis) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            type="button"
            class="metrics-nav"
            aria-label="Next metrics"
            :disabled="!metricsScrollCanNext"
            @click="scrollMetrics(1)"
          >
            <i class="fal fa-chevron-right"></i>
          </button>
        </div>

        <div class="activity-section">
          <div class="activity-table-wrapper">
            <h3 class="section-title">Recent Fast Activity</h3>
            <div class="table-container">
              <data-table :value="activity" :searchBar="false" :rows="5" :rowsPerPageOptions="[5]">
                <column field="tenant" header="Client" bodyStyle="text-align: center" headerStyle="width: 200px"
                        sortable />
                <column field="action" header="Action" bodyStyle="text-align: center" headerStyle="width: 250px"
                        sortable />
                <column field="status" header="Status" bodyStyle="text-align: center" headerStyle="width: 250px"
                        sortable >
                  <template #body="slot">
                    <span class="status-badge" :class="slot.data.status.toLowerCase()">{{slot.data.status}}</span>
                  </template>
                </column>
                <column field="quantity" header="Total Devices" bodyStyle="text-align: center"
                        headerStyle="width: 250px" sortable />
                <column field="date" header="Date" bodyStyle="text-align: center" headerStyle="width: 200px" sortable>
                  <template #body="slot">
                    <span>{{ slot.data.date ? $formatDateTime(slot.data.date) : '-' }}</span>
                  </template>
                </column>
              </data-table>
            </div>
          </div>

          <div class="quick-links-wrapper">
            <h3 class="section-title">Quick Links</h3>
            <div class="quick-links">
              <button class="quick-link-btn" @click="goToDetailedBillingReport">
                <div class="quick-link-content">
                  <i class="fal fa-chart-column quick-link-icon"></i>
                  <span class="quick-link-text">Detailed Billing Report</span>
                </div>
                <i class="fal fa-chevron-right arrow"></i>
              </button>
              <button class="quick-link-btn" @click="goToBillingAccount">
                <div class="quick-link-content">
                  <i class="fal fa-building quick-link-icon"></i>
                  <span class="quick-link-text">Billing Accounts</span>
                </div>
                <i class="fal fa-chevron-right arrow"></i>
              </button>
              <button v-if="!isAllAccountsSelected" class="quick-link-btn" @click="goToPausedDevices">
                <div class="quick-link-content">
                  <i class="fal fa-pause quick-link-icon"></i>
                  <span class="quick-link-text">Manage Paused Devices</span>
                </div>
                <i class="fal fa-chevron-right arrow"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="devices-container" v-if="tabActive === 1">
        <data-table :value="billingMetadataDevices">
          <column field="deviceId" header="Device ID" headerStyle="width: 200px" sortable></column>
          <column field="vehicleId" header="Vehicle ID" bodyStyle="text-align: center" headerStyle="width: 250px" sortable></column>
          <column field="fastProcessTime" header="Fast Process Time" bodyStyle="text-align: center" headerStyle="width: 250px" sortable></column>
          <column field="period" header="Period" bodyStyle="text-align: center" headerStyle="width: 250px" sortable></column>
          <column field="fleet" header="Fleet" bodyStyle="text-align: center" headerStyle="width: 250px" sortable></column>
          <column field="type" header="Type" bodyStyle="text-align: center" headerStyle="width: 250px" sortable></column>
        </data-table>
      </div>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page.vue'
import DataTable from '@/components/DataTable.vue'
import Column from 'primevue/column'
import FormButton from '@/components/FormButton.vue'

import Chart from 'chart.js/auto'
import 'chartjs-adapter-luxon'
import gql from 'graphql-tag'

import {
  goToBillingAccount,
  goToBillingReport,
  goToPausedDevices,
  isAllAccountsSelected as checkAllAccounts
} from '@/lib/billing-navigation'

const chartColors = {
  main: '#131415',
  accent: '#ff5421',
  danger: '#ce2029',
  warning: '#ff9800',
  success: '#22c55e',
  contrast: '#f4f4f5',
  contrastMuted: '#71717a',
  contrastDark: '#27272a',
  contrastLight: '#d4d4d8'
}

export default {
  name: 'SaasDashboardView',
  components: {
    Page,
    DataTable,
    Column,
    FormButton
  },

  data () {
    return {
      loading: true,
      tabActive: 0,
      stats: {
        tvl: {
          billable: 0,
          nonBillable: 0,
          totalDevices: 0
        },
        api: {
          billable: 0,
          nonBillable: 0,
          totalDevices: 0
        }
      },
      billingMetadata: null,
      billingMetadataDevices: [],
      metrics: {
        monthly: {
          devices: 1,
          apis: 1
        },
        longTerm: {
          devices: 1,
          apis: 1
        },
        trial: {
          devices: 1,
          apis: 1
        },
        nonBillable: {
          devices: 1,
          apis: 1
        },
        sleepDisabled: {
          tvl: 1,
          api: { paused: 1 }
        },
        rnd: {
          devices: 1,
          apis: 1
        },
        marketingDevices: {
          devices: 1,
          apis: 1
        }
      },

      chartData: {
        datasets: [
          {
            label: 'TVL Billing Activation',
            data: [],
            borderColor: chartColors.accent,
            hidden: true,
            backgroundColor: this.hexToRgba(chartColors.accent, 0.1),
            tension: 0.1,
            fill: true,
            pointRadius: 4,
            pointHoverRadius: 6,
            pointBackgroundColor: chartColors.accent,
            pointBorderColor: chartColors.contrast,
            pointBorderWidth: 2,
            pointHoverBackgroundColor: chartColors.contrast,
            pointHoverBorderColor: chartColors.accent,
            borderWidth: 2
          },
          {
            label: 'API Billing Activation',
            data: [],
            borderColor: chartColors.warning,
            hidden: true,
            backgroundColor: this.hexToRgba(chartColors.warning, 0.1),
            tension: 0.1,
            fill: true,
            pointRadius: 4,
            pointHoverRadius: 6,
            pointBackgroundColor: chartColors.warning,
            pointBorderColor: chartColors.contrast,
            pointBorderWidth: 2,
            pointHoverBackgroundColor: chartColors.contrast,
            pointHoverBorderColor: chartColors.warning,
            borderWidth: 2
          },
          {
            label: 'FAST Activity',
            data: [],
            borderColor: chartColors.success,
            hidden: false,
            backgroundColor: this.hexToRgba(chartColors.success, 0.1),
            tension: 0.1,
            fill: true,
            pointRadius: 4,
            pointHoverRadius: 6,
            pointBackgroundColor: chartColors.success,
            pointBorderColor: chartColors.contrast,
            pointBorderWidth: 2,
            pointHoverBackgroundColor: chartColors.contrast,
            pointHoverBorderColor: chartColors.success,
            borderWidth: 2
          }
        ],
        labels: []
      },

      activity: [],
      chartInstance: null,

      metricsScrollCanPrev: false,
      metricsScrollCanNext: false
    }
  },

  mounted () {
    window.addEventListener('resize', this.updateMetricsScrollNav)
    this.$nextTick(this.updateMetricsScrollNav)
    this.getSaasDashboardData()
  },

  methods: {
    setActiveTab (tab) {
      if (tab === this.tabActive) return

      if (tab !== 0) {
        this.destroyChart()
      }

      this.tabActive = tab

      if (tab === 0) {
        this.renderDashboardWidgets()
      }
    },

    renderDashboardWidgets () {
      this.$nextTick(() => {
        this.initChart()
        this.updateMetricsScrollNav()
      })
    },

    destroyChart () {
      if (this.chartInstance) {
        this.chartInstance.destroy()
        this.chartInstance = null
      }
    },

    initChart () {
      const ctx = this.$refs.evolutionChartCanvas
      if (!ctx) return

      const colors = chartColors

      if (this.chartInstance) {
        this.destroyChart()
      }

      this.chartInstance = new Chart(ctx, {
        type: 'line',
        data: {
          datasets: this.chartData.datasets.map((dataset, index) => ({
            tension: 0.35,
            pointRadius: 4,
            pointHoverRadius: 6,
            pointBackgroundColor: index === 0 ? colors.accent : colors.success,
            pointBorderColor: colors.contrast,
            pointBorderWidth: 2,
            pointHoverBackgroundColor: colors.contrast,
            pointHoverBorderColor: index === 0 ? colors.accent : colors.success,
            borderWidth: 2,
            ...dataset
          }))
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'top',
              labels: {
                color: colors.contrastLight,
                font: {
                  size: 12
                }
              }
            },
            tooltip: {
              backgroundColor: this.hexToRgba(colors.main, 0.9),
              titleColor: colors.contrast,
              bodyColor: colors.contrastLight,
              borderColor: colors.contrastDark,
              borderWidth: 1
            }
          },
          scales: {
            x: {
              type: 'time',
              time: {
                unit: 'month',
                tooltipFormat: 'LLL/yy',
                displayFormats: {
                  month: 'LLL/yy'
                }
              },
              title: {
                display: true,
                text: 'Month'
              },
              ticks: {
                color: colors.contrastLight
              },
              grid: {
                color: this.hexToRgba(colors.contrastDark, 0.5)
              }
            },
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Devices'
              },
              ticks: {
                color: colors.contrastLight
              },
              grid: {
                color: this.hexToRgba(colors.contrastDark, 0.5)
              }
            }
          }
        }
      })
    },

    hexToRgba (hex, alpha = 1) {
      const r = parseInt(hex.slice(1, 3), 16)
      const g = parseInt(hex.slice(3, 5), 16)
      const b = parseInt(hex.slice(5, 7), 16)
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    },

    formatNumber (num) {
      if (num == null || isNaN(num)) return '0'
      return num.toLocaleString('en-US')
    },

    formatBillingTerm (term) {
      if (term === 'monthly') return 'Monthly'
      if (term === 'prepaid') return 'Prepaid'
      return ''
    },

    resolveBillingTerm (monthly, prepaid) {
      const m = monthly ?? 0
      const p = prepaid ?? 0
      if (m > 0 && p === 0) return 'monthly'
      if (p > 0 && m === 0) return 'prepaid'
      return null
    },

    updateMetricsScrollNav () {
      const el = this.$refs.metricsScroll
      if (!el || typeof window === 'undefined' || window.innerWidth < 768) {
        this.metricsScrollCanPrev = false
        this.metricsScrollCanNext = false
        return
      }
      const maxScroll = el.scrollWidth - el.clientWidth
      if (maxScroll <= 1) {
        this.metricsScrollCanPrev = false
        this.metricsScrollCanNext = false
        return
      }
      this.metricsScrollCanPrev = el.scrollLeft > 2
      this.metricsScrollCanNext = el.scrollLeft < maxScroll - 2
    },

    scrollMetrics (dir) {
      const el = this.$refs.metricsScroll
      if (!el) return
      const card = el.querySelector('.metric-card')
      const grid = el.querySelector('.metrics-grid')
      if (!card) return
      const gapPx = parseFloat(grid ? getComputedStyle(grid).gap : '16') || 16
      const step = card.offsetWidth + gapPx
      el.scrollBy({ left: dir * step, behavior: 'smooth' })
      window.setTimeout(() => this.updateMetricsScrollNav(), 400)
    },

    goToDetailedBillingReport () {
      goToBillingReport(this.$router, this.$store, this.$apollo)
    },

    goToBillingAccount () {
      goToBillingAccount(this.$router, this.$store, this.$apollo)
    },

    goToPausedDevices () {
      goToPausedDevices(this.$router, this.$store, this.$apollo)
    },

    setActivityFallback () {
      this.activity = [{
        tenant: '-',
        action: 'Batch Device Sync',
        status: 'No data',
        quantity: 0,
        date: null
      }]
    },

    defaultZeroMetrics () {
      return {
        monthly: { devices: 0, apis: 0 },
        longTerm: { devices: 0, apis: 0 },
        trial: { devices: 0, apis: 0 },
        nonBillable: { devices: 0, apis: 0 },
        sleepDisabled: { tvl: 0, api: { paused: 0 } },
        rnd: { devices: 0, apis: 0 },
        marketingDevices: { devices: 0, apis: 0 }
      }
    },

    isApiBillingAccount () {
      if (this.isAllAccountsSelected) return false

      const systemId = String(this.$store.state.workingAccount?.system?.id || '').toLowerCase()
      if (systemId === 'api') return true

      const apiTotal = this.stats.api.totalDevices ||
        (this.stats.api.billable + this.stats.api.nonBillable)
      const tvlTotal = this.stats.tvl.totalDevices ||
        (this.stats.tvl.billable + this.stats.tvl.nonBillable)

      if (apiTotal > 0 && tvlTotal === 0) return true
      if (tvlTotal > 0 && apiTotal === 0) return false

      return this.stats.api.billable > this.stats.tvl.billable
    },

    applyChartDatasetDefaults () {
      const isApi = this.isApiBillingAccount()
      const [tvl, api, fast] = this.chartData.datasets

      if (isApi) {
        tvl.hidden = true
        api.hidden = false
        fast.hidden = true
      } else {
        tvl.hidden = true
        api.hidden = true
        fast.hidden = false
      }
    },

    applyDashboardData (dashboardData) {
      if (!dashboardData) {
        this.stats = {
          tvl: { billable: 0, nonBillable: 0, totalDevices: 0 },
          api: { billable: 0, nonBillable: 0, totalDevices: 0 }
        }
        this.billingMetadata = null
        this.billingMetadataDevices = []
        this.metrics = this.defaultZeroMetrics()
        this.tabActive = 0
        this.applyChartDatasetDefaults()
        return
      }

      const apiStats = dashboardData.api && typeof dashboardData.api === 'object'
        ? dashboardData.api
        : { billable: 0, nonBillable: 0, totalDevices: 0 }
      const tvlStats = dashboardData.tvl && typeof dashboardData.tvl === 'object'
        ? dashboardData.tvl
        : { billable: 0, nonBillable: 0, totalDevices: 0 }

      const chartData = dashboardData.chart

      const mapChartData = (data) => {
        return data.map(item => ({
          x: item.month,
          y: item.totalDevices
        })) || []
      }

      if (chartData) {
        this.chartData.datasets[0].data = mapChartData(chartData.tvl)
        this.chartData.datasets[1].data = mapChartData(chartData.api)
        this.chartData.datasets[2].data = mapChartData(chartData.fast)
      }

      this.stats = {
        tvl: {
          billable: tvlStats.billable ?? 0,
          nonBillable: tvlStats.nonBillable ?? 0,
          totalDevices: tvlStats.totalDevices ?? 0
        },
        api: {
          billable: apiStats.billable ?? 0,
          nonBillable: apiStats.nonBillable ?? 0,
          totalDevices: apiStats.totalDevices ?? 0
        }
      }

      if (!dashboardData.billing) {
        this.billingMetadata = null
        this.billingMetadataDevices = []
        this.metrics = this.defaultZeroMetrics()
        this.tabActive = 0
        this.applyChartDatasetDefaults()
        return
      }

      this.billingMetadata = dashboardData.billing.metadata || null
      this.billingMetadataDevices = []
      if (!this.billingMetadata) {
        this.tabActive = 0
      }
      const keys = ['prepaid', 'paused', 'customerSatisfaction', 'monthly', 'rnd', 'marketingDevices']
      if (this.billingMetadata) {
        keys.forEach(key => {
          const tvlDevices = this.billingMetadata.tvl?.[key]
          if (tvlDevices?.length) {
            this.billingMetadataDevices.push(...tvlDevices)
          }
          const apiDevices = this.billingMetadata.api?.[key]
          if (apiDevices?.length) {
            this.billingMetadataDevices.push(...apiDevices)
          }
        })
      }

      const billingApi = dashboardData.billing.api || {}
      const billingTvl = dashboardData.billing.tvl || {}
      this.metrics = {
        monthly: {
          devices: billingTvl.monthly ?? 0,
          apis: billingApi.monthly ?? 0
        },
        longTerm: {
          devices: billingTvl.prepaid ?? 0,
          apis: billingApi.prepaid ?? 0
        },
        trial: {
          devices: billingTvl.customerSatisfaction ?? 0,
          apis: billingApi.customerSatisfaction ?? 0
        },
        nonBillable: {
          devices: billingTvl.nonBillable ?? 0,
          apis: billingApi.nonBillable ?? 0
        },
        sleepDisabled: {
          tvl: billingTvl.paused ?? 0,
          api: {
            paused: billingApi.paused ?? 0
          }
        },
        rnd: {
          devices: billingTvl.rnd ?? 0,
          apis: billingApi.rnd ?? 0
        },
        marketingDevices: {
          devices: billingTvl.marketingDevices ?? 0,
          apis: billingApi.marketingDevices ?? 0
        }
      }

      this.applyChartDatasetDefaults()
    },

    mapOrdersToActivity (orders) {
      const legacyAccountId = this.$store.state.workingAccount?.legacyAccountId ?? this.$store.state.workingAccount?.value
      const accountIdForFilter = legacyAccountId == null || Number(legacyAccountId) === 0
        ? null
        : String(legacyAccountId)
      const filteredOrders = accountIdForFilter
        ? (orders || []).filter(order => order.client?.id != null && String(order.client.id) === accountIdForFilter)
        : (orders || [])

      const mapped = filteredOrders
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .slice(0, 10)
        .map(order => ({
          tenant: order.client?.name || '-',
          action: 'Batch Device Sync',
          status: order.status?.code || '-',
          quantity: order.totalDevices ?? 0,
          date: order.createdAt
        }))

      if (mapped.length === 0) {
        this.setActivityFallback()
        return
      }

      this.activity = mapped
    },

    getSaasDashboardData () {
      this.loading = true
      const legacyAccountId = this.$store.state.workingAccount?.legacyAccountId
      const accountIdForQuery = legacyAccountId == null || Number(legacyAccountId) === 0
        ? null
        : String(legacyAccountId)

      const dashboardQuery = this.$apollo.query({
        query: gql`
          query Dashboard($accountId: ID) {
            dashboard {
              getDashboard(accountId: $accountId) {
                tvl {
                  billable
                  nonBillable
                  totalDevices
                }

                api {
                  billable
                  nonBillable
                  totalDevices
                }

                chart {
                  api {
                    month
                    totalDevices
                  }
                  tvl {
                    month
                    totalDevices
                  }
                  fast {
                    month
                    totalDevices
                  }
                }

                billing {
                  metadata {
                    api {
                      prepaid {
                        accountId
                        deviceId
                        fastProcessTime
                        fleet
                        period
                        system
                        type
                        vehicleId
                      }
                      paused {
                        accountId
                        deviceId
                        fastProcessTime
                        fleet
                        period
                        system
                        type
                        vehicleId
                      }
                      customerSatisfaction {
                        accountId
                        deviceId
                        fastProcessTime
                        fleet
                        period
                        system
                        type
                        vehicleId
                      }
                      monthly {
                        accountId
                        deviceId
                        fastProcessTime
                        fleet
                        period
                        system
                        type
                        vehicleId
                      }
                      rnd {
                        accountId
                        deviceId
                        fastProcessTime
                        fleet
                        period
                        system
                        type
                        vehicleId
                      }
                      marketingDevices {
                        accountId
                        deviceId
                        fastProcessTime
                        fleet
                        period
                        system
                        type
                        vehicleId
                      }
                    }
                    tvl {
                      prepaid {
                        accountId
                        deviceId
                        fastProcessTime
                        fleet
                        period
                        system
                        type
                        vehicleId
                      }
                      paused {
                        accountId
                        deviceId
                        fastProcessTime
                        fleet
                        period
                        system
                        type
                        vehicleId
                      }
                      customerSatisfaction {
                        accountId
                        deviceId
                        fastProcessTime
                        fleet
                        period
                        system
                        type
                        vehicleId
                      }
                      monthly {
                        accountId
                        deviceId
                        fastProcessTime
                        fleet
                        period
                        system
                        type
                        vehicleId
                      }
                      rnd {
                        accountId
                        deviceId
                        fastProcessTime
                        fleet
                        period
                        system
                        type
                        vehicleId
                      }
                      marketingDevices {
                        accountId
                        deviceId
                        fastProcessTime
                        fleet
                        period
                        system
                        type
                        vehicleId
                      }
                    }
                  }
                  api {
                    customerSatisfaction
                    monthly
                    nonBillable
                    paused
                    prepaid
                    rnd
                    marketingDevices
                  }
                  tvl {
                    customerSatisfaction
                    monthly
                    nonBillable
                    paused
                    prepaid
                    rnd
                    marketingDevices
                  }
                }
              }
            }
          }
        `,
        variables: {
          accountId: accountIdForQuery
        },
        fetchPolicy: 'no-cache'
      })

      const ordersQuery = this.$apollo.query({
        query: gql`
          query {
            fast {
              orders: getOrders {
                id: _id
                client {
                  id
                  name
                }
                status {
                  code
                }
                totalDevices
                createdAt
              }
            }
          }
        `,
        fetchPolicy: 'no-cache'
      })

      dashboardQuery
        .then(response => {
          this.applyDashboardData(response.data?.dashboard?.getDashboard)
        })
        .catch(err => {
          console.error('SaaS dashboard metrics:', err.message)
        })

      ordersQuery
        .then(response => {
          this.mapOrdersToActivity(response.data?.fast?.orders || [])
        })
        .catch(err => {
          console.error('SaaS dashboard orders:', err.message)
          this.setActivityFallback()
        })

      Promise.allSettled([dashboardQuery, ordersQuery]).finally(() => {
        this.loading = false
        if (this.tabActive === 0) {
          this.renderDashboardWidgets()
        }
      })
    }
  },

  computed: {
    isAllAccountsSelected () {
      return checkAllAccounts(this.$store.state.workingAccount)
    },

    billingTerm () {
      const m = this.metrics
      return {
        tvl: this.resolveBillingTerm(m.monthly?.devices, m.longTerm?.devices),
        api: this.resolveBillingTerm(m.monthly?.apis, m.longTerm?.apis)
      }
    }
  },

  watch: {
    '$store.state.workingAccount': {
      handler () {
        this.getSaasDashboardData()
      },
      deep: true
    }
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.updateMetricsScrollNav)
    this.destroyChart()
  }
}
</script>

<style lang="less" scoped>
.saas-dashboard {
  flex: 1;
  overflow-y: auto;
  background-color: tint(contrast(contrast(@main-color)), 6%);
  padding: 32px;
}

.dashboard-container {
  max-width: 1280px;
  margin: 0 auto;
}

.dashboard-header {
  margin-bottom: 32px;
}

.dashboard-title {
  font-size: 30px;
  font-weight: 300;
  color: #f4f4f5;
  margin: 0;
}

.dashboard-subtitle {
  color: #71717a;
  font-size: 14px;
  margin-top: 4px;
  margin-bottom: 0;
}

.stats-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 32px;

  @media (min-width: 768px) {
    flex-direction: row;
  }

  .stat-card {
    flex: 1;
  }
}

.stat-card {
  background-color: fade(contrast(@main-color), 5%);
  border: 1px solid #27272a;
  padding: 24px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}

.header-card {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 24px;
}

.stat-content {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.stat-label {
  color: #71717a;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

.stat-value {
  font-size: 36px;
  font-weight: bold;
  color: #ffffff;
  letter-spacing: -0.02em;
  margin: 0;
  margin-top: 16px;
  line-height: 1.2;
}

.stat-value-muted {
  color: #71717a;
}

.stat-badge {
  display: flex;
  align-items: center;
  background-color: fade(@accent-color, 10%);
  color: @accent-color;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 18px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  width: fit-content;

  &.green {
    background: fade(@success-color, 10%);
    color: @success-color;
  }

  &.red {
    background: fade(@danger-color, 10%);
    color: fade(@danger-color, 80%);
    opacity: 0.8;
  }

  &.blue {
    background: fade(#007bff, 10%);
    color: #007bff;
    opacity: 0.8;
  }

  i {
    font-size: 16px;
    opacity: 0.8;
  }
}

.stat-values-container {
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  flex: 1;
}

.stat-item {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0;
  align-items: center;
  min-width: 0;

  &:first-child {
    border-right: 1px solid fade(contrast(@main-color), 5%);
  }
}

.stat-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid fade(contrast(@main-color), 5%);
}

.stat-term-badge {
  flex-shrink: 0;
  padding: 4px 10px;
  border-radius: 4px;
  background-color: rgba(255, 84, 33, .1);
  color: #ff5421;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.stat-trend {
  color: #71717a;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.stat-trend-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
}

.stat-trend-text {
  color: #71717a;
  font-size: 12px;
}

.chart-card {
  background-color: fade(contrast(@main-color), 5%);
  border: 1px solid #27272a;
  padding: 24px;
  border-radius: 8px;
  margin-bottom: 32px;
}

.chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.chart-title {
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  margin: 0;
}

.chart-actions {
  display: flex;
  gap: 8px;
}

.chart-btn {
  padding: 4px 12px;
  font-size: 12px;
  background-color: #27272a;
  color: #d4d4d8;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: #3f3f46;
  }
}

.chart-container {
  height: 300px;
  width: 100%;
}

.metrics-carousel {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 32px;
}

.metrics-nav {
  display: flex;
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid #27272a;
  border-radius: 20px;
  background-color: fade(contrast(@main-color), 5%);
  color: #d4d4d8;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  i {
    color: #ff5421
  }

  &:hover:not(:disabled) {
    background-color: #3f3f46;
  }

  &:disabled {
    opacity: 0.25;
    cursor: default;
  }

  @media (max-width: 767px) {
    display: none;
  }
}

.metrics-scroll {
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  scroll-behavior: smooth;
  container-type: inline-size;

  @media (min-width: 768px) {
    padding-bottom: 6px;
  }

  @media (max-width: 767px) {
    overflow-x: visible;
    container-type: normal;
  }

  &::-webkit-scrollbar {
    height: 6px;
  }
}

.metrics-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 768px) {
    flex-direction: row;
    flex-wrap: nowrap;
  }

  .metric-card {
    flex: 1 1 auto;

    @media (min-width: 768px) {
      flex: 0 0 calc((100cqi - 4 * 16px) / 5);
      min-width: 0;
    }
  }
}

.metric-card {
  background-color: fade(contrast(@main-color), 5%);
  border: 1px solid #27272a;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}

.metric-title {
  font-size: 16px;
  color: #71717a;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-align: center;
  margin: 0 0 16px;
  padding-bottom: 8px;
  overflow-wrap: break-word;
  word-break: break-word;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 14px;
    letter-spacing: 0.05em;
  }
}

.metric-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.metric-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #27272a;
  padding-bottom: 8px;
}

.metric-label {
  font-size: 14px;
  color: #71717a;
  opacity: 0.8;
}

.metric-note {
  font-size: 10px;
  text-transform: lowercase;
  font-style: italic;
  font-weight: normal;
  color: #52525b;
}

.metric-value {
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  margin: 0;
}

.metric-value-primary {
  color: @accent-color;
}

.metric-value-muted {
  color: #a1a1aa;
}

.metric-value-disabled {
  color: #52525b;
}

.activity-section {
  margin-top: 1 0px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  .activity-table-wrapper {
    flex: 1;
  }

  .quick-links-wrapper {
    flex: 1;
  }
}

.section-title {
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 10px;
}

.quick-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.quick-link-btn {
  width: 100%;
  text-align: left;
  padding: 20px;
  background-color: fade(contrast(@main-color), 5%);
  border: 1px solid #27272a;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background-color 0.2s;

  &:hover {
    background-color: #27272a;
  }
}

.quick-link-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.quick-link-icon {
  color: @accent-color;
  font-size: 20px;
}

.arrow {
  color: lighten(@accent-color, 10%);
  font-size: 14px;
  transition: color 0.2s;
}

.quick-link-text {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
}

.quick-link-arrow {
  font-size: 14px;
  color: #52525b;
  transition: color 0.2s;
}

.quick-link-btn:hover .quick-link-arrow {
  color: #a1a1aa;
}

.status-badge {
  background: fade(@success-color, 10%);
  color: @success-color;
  padding: 5px 12px;
  border-radius: 3px;
  font-weight: bold;

  &.processed {
    @color: lighten(@success-color, 20%);

    background: fade(@color, 10%);
    color: @color;
  }

  &.replacement_requested {
    @color: lighten(@warning-color, 20%);

    background: fade(@color, 10%);
    color: @color;
  }

  &.failed {
    @color: lighten(@danger-color, 20%);

    background: fade(@color, 10%);
    color: @color;
  }
}

</style>
